import { render } from "./LoadingText.vue?vue&type=template&id=cb767146&scoped=true"
import script from "./LoadingText.vue?vue&type=script&lang=js"
export * from "./LoadingText.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=cb767146&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb767146"]])

export default __exports__